/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";

export const LoginFormContainer = styled.div`
  width: 480px;
  display: flex;
  flex-direction: column;
  padding: 80px 40px;
  margin: 0 auto;
  align-items: center;
  box-sizing: border-box;
`;

export const InputForm = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 80px;
  width: 100%;
  gap: 24px;
`;

export const SettingContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin: 16px 0 40px 0;
`;

export const AutoLoginCheckContainer = styled.div`
  display: flex;
  gap: 4px;
  align-items: center;
`;

export const LoginBtnContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 100%;
`;

export const Line = styled.div`
  height: 1px;
  background-color: var(--alias-color-line-normal);
`;

export const SignupContainer = styled.div`
  margin-top: 16px;
  display: flex;
  gap: 8px;
  align-items: center;
`;
